import { Message } from 'element-ui'
import { uploadImg } from '@/apps/open/services/upload'
import { ACCOUNT_URL } from '@/apps/open/constants'
import { ResponseError, ErrorCode } from './axios'
import store from '@/apps/open/store'
import router from '../router'
import { OPTION, OPTION_VALUE } from '@/apps/open/types'

const isPrivate = process.env.VUE_APP_IS_PRIVATE
const isPriDocMiddle = process.env.VUE_APP_DEPLOY_ENVIRONMENT === 'private_doc'

export function reqUploadImg (options: any, parent: any, isDeveloper = false) {
  if (!options.file) {
    return
  }
  let fileReader = new FileReader()
  fileReader.readAsDataURL(options.file)
  fileReader.onload = () => {
    uploadImg(String(fileReader.result), options.action, progressEvent => {
      parent.uploadPercent = Number((progressEvent.loaded * 100 / progressEvent.total).toFixed())
    }).then((resp) => {
      const result = resp.data.object
      if (isDeveloper) {
        parent.info = { ...parent.info, business_license: result }
      } else {
        parent.info = { ...parent.info, logo: result }
      }
      parent.uploadState = 0
      parent.uploadPercent = 0
    }).catch((error: Error) => {
      parent.$message.error(error.message)
      parent.uploadState = 0
      parent.uploadPercent = 0
    })
  }
}

export function detectMob () {
  if (navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)) {
    return true
  } else {
    return false
  }
}

export function goLogin () {
  let currentUrl
  if (isPriDocMiddle && location.pathname === '/') {
    currentUrl = `${location.origin}/open`
  } else {
    currentUrl = window.location.href
  }
  window.location.href = ACCOUNT_URL + currentUrl
}

export async function onRequestError (error: ResponseError, message?: string) {
  switch (error.code) {
    case ErrorCode.UserNotLogin:
      goLogin()
      return
    case ErrorCode.PermissionDenied:
      Message.error('没有当前应用的操作权限')
      try {
        await store.dispatch('User/GET_USER_INFO')
        router.replace({ name: 'developer-info' })
      } catch (error) {
        // router.replace({ name: 'home' })
      }
      return
    default:
      break
  }
  Message.error(message || error.message)
}

export function getSelectOptionLabel (value: OPTION_VALUE, options: OPTION[]) {
  if (!options) {
    return ''
  }
  let optionLabel = ''
  const recursiveData = (list: OPTION[]) => {
    list.forEach((item: OPTION) => {
      if (item.value === value) {
        optionLabel = item.label.toString()
        return
      }
      if (item.children && item.children.length) {
        recursiveData(item.children)
      }
    })
  }
  recursiveData(options)
  return optionLabel
}

function jumpPage (link: string, isNewTab?: boolean, curPath?: string) {
  isNewTab ? window.open(`${isPrivate ? '#' : ''}${link}`) : curPath ? (curPath.indexOf(link) !== 0 && router.push(link)) : router.push(link)
}

export function goApply (apply_link?: string, isNewTab: boolean = true, curPath?: string) {
  const curEnterprise = store.getters['User/curEnterprise']
  const isJoinEnterprisePlus = store.getters['Plussvr/isJoinEnterprisePlus']
  if (detectMob()) {
    Message({
      message: '请在PC端执行此操作',
      type: 'warning',
      offset: 80
    })
    return
  }
  if (!store.getters['User/isLogin']) {
    goLogin()
  } else if (!isJoinEnterprisePlus) {
    if (!store.getters['User/isDeveloper'] || store.getters['User/isRejectedDeveloper']) {
      jumpPage('/apply-developer', isNewTab, curPath)
    } else if (store.getters['User/isPassedDeveloper'] || store.getters['User/isPendingDeveloper']) {
      if (apply_link) jumpPage(apply_link, isNewTab, curPath)
      else jumpPage('/developer-info', isNewTab, curPath)
    }
  } else if (isJoinEnterprisePlus) {
    if (curEnterprise.developer_id) {
      if (apply_link) jumpPage(apply_link, isNewTab, curPath)
      else jumpPage('/developer-info', isNewTab, curPath)
    } else if (!curEnterprise.developer_id) {
      jumpPage('/app-access', isNewTab, curPath)
    } else {
      jumpPage('/apply-developer', isNewTab, curPath)
    }
  } else {
    jumpPage('/apply-developer', isNewTab, curPath)
  }
}
